import { render, staticRenderFns } from "./checkbox-control.vue?vue&type=template&id=0b04cd4e&"
import script from "./checkbox-control.vue?vue&type=script&lang=js&"
export * from "./checkbox-control.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports